import moment from "moment";
import Modal from '@mui/material/Modal';
import { useEffect, useState } from "react";
import { Oval } from 'react-loader-spinner';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from "react-redux";

import Loader from "../../../../components/Loader";
import 'react-circular-progressbar/dist/styles.css';
import { toggleModal } from "../../../../reducers/modalReducer";
import { getRequest, postRequest, showMessage } from '../../../../config';

export default function ResearchAid({ company, getCompany, setTab, setCompanyDashboardTab, permissionLevel, isGenerateAllResearchAid }) {

	const dispatch = useDispatch();
	const navigation = useNavigate();

	let user = useSelector(state => state.user);
	let modal = useSelector(state => state.modal);

	let [isSwotReport, setIsSwotReport] = useState(false);
	// Always fetch reports from single endpoint
	let [reports, setReports] = useState([]);
	let [researchAidReports, setResearchAidReports] = useState([]);
	let [loadingReports, setLoadingReports] = useState(false);

	// Fetch reports from single endpoint
	useEffect(() => {
		const fetchReports = async () => {
			if (company?._id && !loadingReports) {
				setLoadingReports(true);
				try {
					const response = await getRequest(`/company/${company._id}/reports`);
					if (response['code'] == 200 && response['body']?.['reports']) {
						setReports(response['body']['reports']['customReports'] || []);
						setResearchAidReports(response['body']['reports']['researchAidReports'] || []);
					}
				} catch (e) {
					console.error('Failed to fetch reports:', e);
				} finally {
					setLoadingReports(false);
				}
			}
		};
		fetchReports();
	}, [company?._id]);

	const deleteHistoryRecord = async (reportId, historyId, type) => {
		if (reportId && historyId) {
			let res = await postRequest(`/company/deleteReportHistory`, { reportId, historyId });
			if (res['code'] == '200') {
				getCompany(); // remove record from frontend from history array
			}
		}
	};

	const handleReportName = (report) => {
		if (report['reportType'] == 'swotAnalysis') {
			if (report?.['disableSwotReport']) setIsSwotReport(true);
			else setIsSwotReport(false);
			dispatch(toggleModal({ open: 'swotReportPopup' }));
		}
	};

	const handleReportRedirect = (report) => {
		// CHECK EXPANSION PACK PERMISSIONS LEVEL OF ADVISORS/INVESTORS
		if ((user['role'] == "Advisor" || user['role'] == "Investor") && (permissionLevel == 'DASHBOARD')) {
			showMessage(`You have ${permissionLevel} access only!`);
			return;
		};

		setTab(`${report['_id']}?${report['reportType']}-researchaid`);
		setCompanyDashboardTab('Dashboard');
	};

	const reportCard = (report, type) => {
		let creator;
		if (report?.['createdBy']) creator = report?.['createdBy'];
		return <div className={`bo7 w25 keyfeature-wihte-item bg1 new-shadow br15px p2rem mx1rem my1-5rem pr bsbb`}>
			<div className='right-info-hyper-icon' style={{ top: '-20px', right: '-20px' }}>
				<div className='cp info-icon pr ml0-5rem'>
					<img className="" src={require(`../../../../../images/three-dot-icon.png`)} alt="three-dot-icon" />
				</div>
			</div>
			<Link className="ttc fs1rem fw500 c15 lh2 zi1 w100">
				<Link className="cp w100 h100" style={{ minHeight: '130px' }}>
					<div className='w100 df aic'>
						<i className='icon-diligenstia mr1rem'><img className="br5px w50px" src={require(`../../../../../images/checklist-logo.png`)} alt="" /></i>
						<div class='df fdc mr1rem'>
							<p className="w100 fs0-75rem fw300 c12 mb0-5rem">Diligentsia ResearchAid</p>
							{report?.['htmlReport']
								? <Link to={permissionLevel != 'DASHBOARD' && `#${report['_id']}?${report['reportType']}-researchaid`} onClick={() => handleReportRedirect(report)} className="w100 fs1rem c15">{report['name'].length > 30 ? report['name'].substring(0, 30) + '...' : report['name']}
								</Link>
								: report['reportType'] == 'swotAnalysis' ? <button onClick={() => handleReportName(report)} className="cp w100 bg1 fs1rem tal c15">{report['name'].length > 30 ? report['name'].substring(0, 30) + '...' : report['name']}</button> : <span className="w100 fs1rem c12 op60">{report['name'].length > 30 ? report['name'].substring(0, 30) + '...' : report['name']}</span>
							}
						</div>
						{(report?.['htmlReport'] && company['subscription'] == 'Pro') && <>
							<Link to={`/researchAid/${company['_id']}#${report['_id']}?${report['reportType']}`} state={{ company }}><i className="cp fa fa-edit pl1rem c3" style={{ fontSize: '20px', fontWeight: '400' }} /></Link>
							{(report?.['history'] && report['history'].length > 0) &&
								<div className='cp module-tooltip-box'>
									<div className='hover-list' style={{ position: 'relative', left: 'auto', top: 'auto' }}><i className="cp fa fa-history pl1rem c4" style={{ fontSize: '20px', fontWeight: '400' }} /></div>
									<span className="tooltip-area tooltip-reaserchaid">
										{report['history'].map(data => {
											return <div className="overlay-box" style={{ padding: '5px 10px' }}>
												<div className="df aic  w100">
													{data?.['userId'] &&
														<span data-tooltip={`${data['userId']?.firstName ?? ''} ${data['userId']?.lastName ?? ''}`} className="shadow w2rem h2rem bg16 bw3px bss bo19 df jcc aic br100 c1 mr0-5rem">
															{data['userId']['profile']
																? <img src={data['userId']['profile']} className="new-shadow w30px h30px df jcc aic br100 bg16 c1" data-tooltip={`${data['userId']?.firstName ?? ''} ${data['userId']?.lastName ?? ''}`} />
																: <span className='bg16 c15 br50px' data-tooltip={`${data['userId']?.firstName ?? ''} ${data['userId']?.lastName ?? ''}`}>
																	{data['userId']?.firstName ? (data['userId'].firstName[0] + (data['userId'].lastName?.[0] || "")) : "?"}
																</span>
															}</span>
													}
													<div className="text-box df aic jcsb w100">
														<p className="c15" style={{ fontSize: '10px' }}>{data['lastUpdatedTime'] && <p>{data['lastUpdatedTime']}</p>}</p>
														<button onClick={() => deleteHistoryRecord(report['_id'], data['_id'], type)}><i className='fa fa-trash c9 cp' style={{ fontSize: '20px', }} /></button>
													</div>
												</div>
											</div>
										})}
									</span>
								</div>
							}
						</>}
					</div>
					<div className={`w100 df jcsb px1rem ${report?.['reportType'] == 'TCAR3' ? 'mt1rem' : 'mt2rem'}`}>
						{!report?.['htmlReport'] && !(report?.['reportType'] == 'swotAnalysis' && report?.['disableSwotReport'])
							? <>
								{isGenerateAllResearchAid
									? <button className={`cna br25px px3rem cp bg16 py0-5rem `}>
										<Oval height="20" width="20" strokeWidth="4" secondaryColor="#f9f9f9" color="#000" ariaLabel="oval-loading" />
									</button>
									: <Link to={`/researchAid/${company['_id']}?${report['reportType']}`}
										// data-tooltip={((user['role'] == 'Advisor' || user['role'] == 'Investor') && user?.['companyId']?.['_id'] != company?.['_id']) ? `${user['role']} can't generate report from company dashboard!` : ''}
										state={{ company }} className={`c1 fs0-75rem fw600 td250 br25px px2rem py0-5rem cp bg4 bg3-hover`}>Generate</Link>
								}
							</>
							: (report?.['htmlReport'] && creator) && <>
								{company['subscription'] == 'Free'
									? <div class='df fdc mt1rem'>
										<p class='w100 fs0-75rem fw300'>Executive Summary only.</p>
										<p class='w100 fs0-75rem fw300'>To <span class='c7 fw500'>UNLOCK</span> upgrade to PRO/LITE</p>
									</div>
									: <div class='df jcsb mt1rem'>
										<span data-tooltip={`${creator?.firstName ?? ''} ${creator?.lastName ?? ''}`} className="shadow w40px h40px bg16 bw3px bss bo19 df jcc aic br100 c1">
											{creator?.profile
												? <img src={creator.profile} className="new-shadow w30px h30px df jcc aic br100 bg16 c1" data-tooltip={`${creator?.firstName ?? ''} ${creator?.lastName ?? ''}`} />
												: <span className='bg16 c15 br50px' data-tooltip={`${creator?.firstName ?? ''} ${creator?.lastName ?? ''}`}>
													{creator?.firstName ? (creator.firstName[0] + (creator.lastName?.[0] || "")) : "?"}
												</span>}
										</span>
										<p class='fs0-75rem c15 ml0-5rem'>{moment(report.createdAt).format('ll')}</p>
									</div>
								}
								<div class='df fdc'>
									<p class={`fs1-5rem tac ${report?.['score'] >= 4 ? 'c34' : report?.['score'] >= 2 ? 'c39' : 'c4'}`}>
										{report?.['score']}
										<span class='fs0-75rem'>/5</span>
									</p>
									<p class='fs0-75rem fw400 c15'>Report <br /> Score</p>
								</div>
							</>}
						{(report?.['reportType'] == 'swotAnalysis' && report?.['disableSwotReport']) &&
							<span className="fs0-75rem fw300 c14 tti">Please complete the other 4 reports prior to generating this report</span>
						}
					</div>
				</Link>
			</Link>
		</div>
	};

	const dummyReportCard = (subscription) => {
		return <div className={`bo7 w25 keyfeature-wihte-item bg1 new-shadow br15px p2rem mx1rem my1-5rem pr bsbb`}>
			<div className='right-info-hyper-icon' style={{ top: '-20px', right: '-20px' }}>
				<div className='cp info-icon pr ml0-5rem'>
					<img className="" src={require(`../../../../../images/three-dot-icon.png`)} alt="three-dot-icon" />
					<div className='overlay-box'><p className='c15'>What is it?</p></div>
				</div>
			</div>
			<Link className="ttc fs1rem fw500 c15 lh2 zi1 w100">
				<Link className="cp w100 h100" style={{ minHeight: '130px' }}>
					<div className='w100 df aic'>
						<i className='icon-diligenstia mr1rem'><img className="br5px w50px" src={require(`../../../../../images/checklist-logo.png`)} alt="" /></i>
						<div class='df fdc mr1rem'>Your Report Here</div>
						{subscription == 'PRO' && <>
							<i data-tooltip='Edit' className="cp fa fa-edit pl1rem c3" style={{ fontSize: '20px', fontWeight: '400' }} />
							<i data-tooltip='History' className="cp fa fa-history pl1rem c4" style={{ fontSize: '20px', fontWeight: '400' }} />
						</>}
					</div>
					<div className="w100 df jcsb mt3rem px1rem">
						<div class='df fdc mt1rem'>
							{subscription == 'PRO'
								? <p class='w100 fs0-75rem fw300'><span class='c7 fw500'>UNLOCK</span> to edit/rerun full report. <br /> Plus create your own reports</p>
								: <p class='w100 fs0-75rem fw300'>Upgrade to LITE. <span class='c7 fw500'>UNLOCK</span> full <br /> report to see how others see you</p>
							}
						</div>
						<div class='df fdc'>
							<p class={`fs1-5rem tac c12`}>0.0</p>
							<p class='fs0-75rem fw400 c12'>Report <br /> Score</p>
						</div>
					</div>

				</Link>
			</Link>
		</div>
	};

	const upgradeCard = (subscription) => {
		return <div className='shadow bg1 tac w100 h200px p1rem br30px'>
			<h4 className="pr" style={{ bottom: '20%' }}><span className="shadow c59 fs1-25rem px1-5rem br10px bw1px bo59 bss ttu" style={{ background: '#E4FFEB' }}>{subscription}</span></h4>
			<div className="subs-btn mt0-5rem">
				<p className="fs1rem fw500 c15 mb0-5rem">Have you thought <br /> about upgrading?</p>
				<Link to={`/billing/${company['_id']}`} className="bg4 bg3-hover fs0-75rem fw600 c1 td250 br30px px3rem py0-5rem cp tac mt0-5rem">Find out more</Link>
			</div>
		</div>
	};

	return (
		<>
			<div className='sectionWrapper py1rem fs0-75rem pr anylist-builder-tab'>
				{/* Pre-Configured Reports */}
				<div className='mt1rem bss px1rem py2rem br25px w100 keyfeature-box-portfolio anylist-checklist df fww mb3rem pr bsbb'>
					<h3 className="fs1-25rem c15 w100 pl1rem mb2rem">Research Aid Reports - <span class='fw600 c7 ttu'>{company['subscription']}</span></h3>
					{(researchAidReports && researchAidReports.length > 0) && researchAidReports.map(item => reportCard(item, 'researchAidReports'))}
					<div className="research-aid-ai-img">
						{researchAidReports && <img className="pa r0 b0" src={require(`../../../../../images/research-aid-ai.png`)} alt="research-aid-ai" />}
					</div>
				</div>

				{/* User Generate Reports */}
				{company['subscription'] == 'Pro' &&
					<div className='mt1rem bss px1rem py2rem br25px w100 keyfeature-box-portfolio anylist-checklist df fww mb3rem pr bsbb'>
						<h3 className="fs1-25rem c15 w100 pl1rem mb2rem">User Generate Reports - <span class='fw600 c7 ttu'>PRO</span></h3>
						<div class='df jcc aic'>
							<Link to={`/researchAid/${company['_id']}?customReport`} state={{ company }} className={`w25 keyfeature-wihte-item br15px p2rem mx1rem cp bg3`}>
								<div className='df aic my3rem'>
									<i className="fa fa-plus-circle cp mr2rem c1" style={{ fontSize: '48px' }} />
									<h3 className='c1 fs1-25rem fw400'>ResearchAid <br /> Report Builder</h3>
								</div>
							</Link>
						</div>
						{(reports && reports.length > 0) && reports.map(item => reportCard(item, 'customReports'))}
						<div className="research-aid-ai-img"><img className="pa r0 b0" src={require(`../../../../../images/research-aid-ai-pro.png`)} alt="research-aid-ai" /></div>
					</div>
				}

				{/* Upgrade to Lite */}
				{(company['subscription'] == 'Free' && !company?.['servicedBy']) &&
					<div className='mt1rem bss px1rem py2rem br25px w100 keyfeature-box-portfolio anylist-checklist df fww mb3rem pr bsbb'>
						<h3 className="fs1-25rem c15 w100 pl1rem">Research Aid Reports - <span class='fw600 c7 ttu'>Lite</span></h3>
						<div class='w100 keyfeature-box keyfeature-box-company-pro df fww mb2rem pr bsbb py1rem'>
							<div className="grs1-md df fdc aic tac w20 mt1rem">
								{upgradeCard('Lite')}
							</div>
							<div className="df fww w80 coreworkspace-update">
								{dummyReportCard('Lite')}
							</div>
						</div>
						<div className="research-aid-ai-img">
							{researchAidReports && <img className="pa r0 b0" src={require(`../../../../../images/research-aid-ai-lite.png`)} alt="research-aid-ai" />}
						</div>
					</div>
				}

				{/* Upgrade to PRO */}
				{(company['subscription'] == 'Free' || company['subscription'] == 'Lite') &&
					<div className='mt1rem bss px1rem py2rem br25px w100 keyfeature-box-portfolio anylist-checklist df fww mb3rem pr bsbb'>
						<h3 className="fs1-25rem c15 w100 pl1rem">Research Aid Reports - <span class='fw600 c7 ttu'>PRO</span></h3>
						<div class='w100 keyfeature-box keyfeature-box-company-pro df fww mb2rem pr bsbb py1rem'>
							<div className="grs1-md df fdc aic tac w20 mt1rem">
								{upgradeCard('PRO')}
							</div>
							<div className="df fww w80 coreworkspace-update">
								{/* Create Custom Report Button */}
								<div data-tooltip='Upgrade to PRO for create custom report' className={`bo7 w25 keyfeature-wihte-item bg3 br15px p2rem mx1rem op30 cna`}>
									<div className='df aic my3rem'>
										<i className="fa fa-plus-circle cp mr2rem c1" style={{ fontSize: '48px' }} />
										<h3 className='c1 fs1-25rem fw400'>ResearchAid <br /> Report Builder</h3>
									</div>
								</div>
								{dummyReportCard('PRO')}
							</div>
						</div>
					</div>
				}
			</div>

			{/* Demo Checklist Flow */}
			<Modal id="swotReportPopup" open={modal['open'] == 'swotReportPopup'} onClose={() => dispatch(toggleModal({ open: '' }))} className="backdrop td500 zi4 pf t0 l0 w100vw  df jcc aic advisor-dashboard-seemore">
				<div className="poppins-font-style mah100 bg1 shadow w100 py2rem px4rem df fdc m1rem pr br10px pr" style={{ outline: 'none', paddingBottom: '2rem', maxWidth: '750px' }}>
					<div className='top-logo pa t0 r0 mr1rem mt1rem'><img className='w4rem' src={require('../../../../../images/favicon.png')} alt="" /></div>
					<div className='df fdc my3rem'>
						<div className='df fdc'>
							<h3 className='fs1-5rem c15 mb1-5rem'>SWOT Analysis Report</h3>
							{isSwotReport
								? <p className="fs1rem c15 mb1rem tac">Generate the other ResearchAid reports before <br /> generating the SWOT Report</p>
								: <p className="fs1rem c15 mb1rem tac">The SWOT report will produce better results if you first generate  <br /> the Technology Competitive Advantage Report</p>
							}
						</div>
						{isSwotReport
							? <div className='df jcc mt2rem'>
								<button onClick={() => dispatch(toggleModal({ open: '' }))} className="bg4 fs0-75rem fw600 c1 td250 br30px px4rem py0-5rem cp tac">Back</button>
							</div>
							: <div className='df jcsa mt2rem'>
								<button onClick={() => dispatch(toggleModal({ open: '' }))} className="bg4 fs0-75rem fw600 c1 td250 br30px px3rem py0-5rem cp tac">Cancel</button>
								<Link to={`/researchAid/${company['_id']}?swotAnalysis`} state={{ company }} className={`fs0-75rem fw600 c1 td250 br30px px3rem py0-5rem cp tac cp bg3`}>Generate</Link>
							</div>
						}
					</div>
					<svg className="pa cp" onClick={() => dispatch(toggleModal({ open: '' }))} style={{ left: '50%', transform: 'translateX(-50%)', bottom: '-80px' }} width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
						<rect opacity="0.8" x="4" y="4" width="52" height="52" rx="26" fill="#151313" />
						<path d="M48.5626 11.4375C44.8913 7.76665 40.214 5.26685 35.1221 4.2542C30.0302 3.24156 24.7523 3.76155 19.9559 5.74843C15.1595 7.73531 11.06 11.0998 8.17569 15.4166C5.29142 19.7333 3.75195 24.8084 3.75195 30C3.75195 35.1917 5.29142 40.2667 8.17569 44.5835C11.06 48.9002 15.1595 52.2647 19.9559 54.2516C24.7523 56.2385 30.0302 56.7585 35.1221 55.7458C40.214 54.7332 44.8913 52.2334 48.5626 48.5625C51.0004 46.1249 52.9342 43.231 54.2535 40.0461C55.5729 36.8611 56.252 33.4474 56.252 30C56.252 26.5526 55.5729 23.1389 54.2535 19.954C52.9342 16.769 51.0004 13.8751 48.5626 11.4375ZM39.3751 36.6375C39.5624 36.8129 39.7117 37.0249 39.8138 37.2603C39.9159 37.4958 39.9686 37.7496 39.9686 38.0063C39.9686 38.2629 39.9159 38.5168 39.8138 38.7522C39.7117 38.9876 39.5624 39.1996 39.3751 39.375C39.1999 39.5488 38.9921 39.6863 38.7636 39.7796C38.5352 39.8729 38.2906 39.9202 38.0438 39.9188C37.5519 39.9167 37.0805 39.7214 36.7313 39.375L30.0001 32.6438L23.3626 39.375C23.0133 39.7214 22.5419 39.9167 22.0501 39.9188C21.8033 39.9202 21.5587 39.8729 21.3302 39.7796C21.1018 39.6863 20.894 39.5488 20.7188 39.375C20.3696 39.0237 20.1736 38.5485 20.1736 38.0531C20.1736 37.5578 20.3696 37.0826 20.7188 36.7313L27.3563 30L20.7188 23.3625C20.4116 23.0038 20.2511 22.5424 20.2694 22.0705C20.2876 21.5986 20.4832 21.151 20.8171 20.8171C21.1511 20.4832 21.5987 20.2875 22.0706 20.2693C22.5425 20.2511 23.0039 20.4116 23.3626 20.7188L30.0001 27.3563L36.6376 20.7188C36.8111 20.539 37.0184 20.3952 37.2476 20.2956C37.4768 20.196 37.7233 20.1424 37.9732 20.1381C38.223 20.1337 38.4713 20.1786 38.7038 20.2702C38.9363 20.3618 39.1484 20.4983 39.3282 20.6719C39.5079 20.8455 39.6517 21.0528 39.7514 21.2819C39.851 21.5111 39.9045 21.7576 39.9089 22.0075C39.9132 22.2573 39.8683 22.5056 39.7767 22.7381C39.6851 22.9706 39.5486 23.1828 39.3751 23.3625L32.6438 30L39.3751 36.6375Z" fill="white" />
					</svg>
				</div>
			</Modal>
		</>
	)
}